import { useEffect, useRef } from "react";
import type { FieldValues, UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";

export function useRevalidateOnLanguageChange<T extends FieldValues>(
  form: UseFormReturn<T>
): void {
  const { i18n } = useTranslation();
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    const errorFieldNames = Object.keys(form.formState.errors);
    if (!errorFieldNames?.length) return;

    form.clearErrors();
    void form.trigger(errorFieldNames as Parameters<typeof form.trigger>[0]);
  }, [i18n.language]); // eslint-disable-line react-hooks/exhaustive-deps
}
